// extracted by mini-css-extract-plugin
module.exports = {"shadow_box":"styles_shadow_box__11q5R"};